import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    TextField
} from "@mui/material";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logUserIn } from "services/redux/site";
import { AppDispatch, RootState } from "services/redux/store";

const Login = () => {
    const { isLoggedIn } = useSelector((state: RootState) => state.site);
    const dispatch = useDispatch<AppDispatch>();

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(() => !showPassword);
    };
    const handleMouseDownPassword = (
        event: React.MouseEvent<HTMLButtonElement>
    ) => {
        event.preventDefault();
    };

    const navigate = useNavigate();
    useEffect(() => {
        if (isLoggedIn) {
            navigate("/");
        }
    }, [isLoggedIn]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        Cookies.set("logedIn", "true", { expires: 1 });
        dispatch(logUserIn());
    };

    return (
        <section className="flex flex-col justify-center items-center h-full">
            <form
                className="card flex flex-col justify-center items-center gap-7 shadow-xl bg-neutral-100 dark:bg-momeento-300 px-10 py-10 rounded"
                style={{ maxWidth: 360 }}
                onSubmit={handleSubmit}
            >
                <div className="w-full">
                    <h1 className="dark:text-white  text-xl font-bold">
                        Login
                    </h1>
                </div>
                <div className="w-full">
                    <TextField
                        id="user-name"
                        name="user-name"
                        label="User Name"
                        variant="outlined"
                        sx={{ width: "100%" }}
                    />
                </div>
                <div className="w-full">
                    <FormControl sx={{ width: "100%" }} variant="outlined">
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <OutlinedInput
                            id="password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? (
                                            <VisibilityOff />
                                        ) : (
                                            <Visibility />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Password"
                        />
                    </FormControl>
                </div>

                <div className="w-full white-span">
                    <FormControlLabel
                        control={
                            <Checkbox id="remember-me" name="remember-me" />
                        }
                        label="Remember Me"
                    />
                </div>

                <div className="w-full px-10">
                    <button
                        className="w-full px-5 py-2 bg-momeento-50 text-white hover:shadow-xl rounded-full"
                        type="submit"
                    >
                        Login
                    </button>
                </div>
            </form>
        </section>
    );
};

export default Login;
